/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_POS_CATEGORIES = gql`
  query GetPosCategories($pagination: OffsetLimitPaginationFilter) {
    posCategories(pagination: $pagination) {
      totalCount
      results {
        category
      }
    }
  }
`
